import React from 'react';
import { Form, DatePicker, Alert } from 'antd';

import moment from 'components/momentWithZone';
import withSpin from 'components/withSpin';
import SaveButton from 'components/SaveButton';

import globalFormItemLayout from 'components/Portal/formItemLayout';
const formItemLayout = Object.assign({}, globalFormItemLayout, {labelCol: {sm: {span: 14}}, wrapperCol: {sm: {span: 6}}});

class Vaccinations extends React.Component {
	state = {
		SRI_YELLOW_FEVER_VAC: null
	}
	handleSubmit = (event) => {
		event.preventDefault();
		this.props.isSubmitting();
		this.props.updateStatuses(this.props.form)
			.catch(console.error)
			.then(() => { this.props.isSubmitted(); });
	}
	getVaccsFromProps = (props) => {
		const statuses = props.statuses || {};
		this.setState({
			SRI_YELLOW_FEVER_VAC: statuses.SRI_YELLOW_FEVER_VAC
		});
	}
	componentDidMount() { this.getVaccsFromProps(this.props); }
	componentWillReceiveProps(nextProps) { this.getVaccsFromProps(nextProps); }
	render() {
		const disabled = this.props.variant !== 'admin' && !this.props.sectionIsEnabled(this.props, 'health/vaccinations');
		if (this.props.variant !== 'admin') {
			const redirect = this.props.redirectIfHidden(this.props, 'health/vaccinations');
			if (redirect) return redirect;
		}
		
		const { getFieldDecorator } = this.props.form;
		return (
			<Form onSubmit={this.handleSubmit}>
				<Alert showIcon type="warning" message="You must bring your vaccination card to the ship with you." />
				<Form.Item label="Date of Yellow Fever Vaccination" {...formItemLayout}>
					{getFieldDecorator('SRI_YELLOW_FEVER_VAC', {
						initialValue: this.state.SRI_YELLOW_FEVER_VAC && moment(this.state.SRI_YELLOW_FEVER_VAC)
					})(<DatePicker disabled={disabled} />)}
				</Form.Item>
				<SaveButton
					disabled={!this.props.form.isFieldsTouched()}
					loading={this.props.getStatus().submitting} />
			</Form>
		);
	}
}

export default withSpin(Form.create()(Vaccinations));



// WEBPACK FOOTER //
// ./portal-components/Portal/Health/Vaccinations.jsx